import { X } from "lucide-react";
import { useId } from "react";
import type { FieldValues, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Input } from "~/components/ui";

interface URLAllowListFormInputProps<F extends FieldValues> {
  register: UseFormRegister<F>;
  basePath: string;
  index: number;
  onRemove: (index: number) => void;
}

export function URLAllowListFormInput<F extends FieldValues>({
  register,
  basePath,
  index,
  onRemove,
}: URLAllowListFormInputProps<F>) {
  const { t } = useTranslation();
  const valueId = useId();
  const regexId = useId();
  return (
    <div className="mt-2 flex items-end gap-2 rounded-[var(--radius-md)] border border-border-default bg-bg-subtle p-2.5">
      <div className="flex-1">
        <label
          htmlFor={valueId}
          className="mb-1 block text-[12px] font-medium text-fg-2"
          title={t("model.propertySchema.urlAllowList.valueInfo")}
        >
          {t("model.propertySchema.urlAllowList.value")}
        </label>
        <Input id={valueId} {...register(`${basePath}.${index}.value` as never)} />
      </div>
      <div className="flex-1">
        <label
          htmlFor={regexId}
          className="mb-1 block text-[12px] font-medium text-fg-2"
          title={t("model.propertySchema.urlAllowList.regexInfo")}
        >
          {t("model.propertySchema.urlAllowList.regex")}
        </label>
        <Input id={regexId} {...register(`${basePath}.${index}.regex` as never)} />
      </div>
      <Button type="button" variant="outline" size="icon" onClick={() => onRemove(index)} aria-label={t("ui.delete")}>
        <X />
      </Button>
    </div>
  );
}
